import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Team } from '../../models/Team';
import { UpcomingMatch } from '../../models/UpcomingMatch';
import { Match } from '../../models/Match';
import { getUpcomingMatches, getMatchesBySeason } from '../../services/MatchService';
import { fetchTeamsBySeason } from '../../services/TeamService';
import { } from '../../services/TeamService';
import { AuthContext } from '../../context/AuthContext';
import { admins, currentSeason, risingAdmins } from '../../Constants';
import EditUpcomingMatchModal from './UpcomingMatchModal';
import { EditMatchModal } from './MatchModal';

const AdminPage = () => {
    const [allTeams, setAllTeams] = useState<Team[]>([]);
    const [upcomingMatches, setUpcomingMatches] = useState<UpcomingMatch[]>([]);
    const [shownMatches, setShownMatches] = useState<UpcomingMatch[]>([]);
    const [matches, setMatches] = useState<Match[]>([]);
    const [selectedUpcomingMatch, setSelectedUpcomingMatch] = useState<UpcomingMatch | null>(null);
    const [selectedMatch, setSelectedMatch] = useState<Match | null>(null);
    const [isUpcomingModalOpen, setIsUpcomingModalOpen] = useState<boolean>(false);
    const [isMatchModalOpen, setIsMatchModalOpen] = useState<boolean>(false);
    const [filterMatches, setFilterMatches] = useState<boolean>(true);

    const [countdown, setCountdown] = useState(10);

    const { user: visitor } = useContext(AuthContext);

    const fetchData = useCallback(async () => {
        try {
            // Mock data for Teams
            const mockTeams = await fetchTeamsBySeason(currentSeason);

            // Mock data for Upcoming Matches
            const mockUpcomingMatches = await getUpcomingMatches();

            // Mock data for Matches
            const mockMatches = await getMatchesBySeason(currentSeason);

            // Setting mock data
            setAllTeams(mockTeams);
            setUpcomingMatches(mockUpcomingMatches);
            setMatches(mockMatches);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        if (filterMatches) {
            setShownMatches(upcomingMatches.filter(match => !match.playoffPlayed));
        } else {
            setShownMatches(upcomingMatches);
        }
    }, [filterMatches, upcomingMatches]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    if (!admins.includes(Number(visitor?.steamID)) && !risingAdmins.includes(Number(visitor?.steamID))) {
        if (countdown === 0) {
            return <>BOOOOOOOOOOOOOOOOOOOOOOOOM 💥💥💥💥💥</>;
        }
        return <div>Du har vist ikke tilladele til at være her. Din computer sprænger i luften om {countdown} 💣</div>;
    }

    const handleUpcomingEdit = (match: UpcomingMatch | null) => {
        setSelectedUpcomingMatch(match);
        setIsUpcomingModalOpen(true); // Ensure modal state is set to true
    };

    const handleMatchEdit = (match: Match) => {
        setSelectedMatch(match);
        setIsMatchModalOpen(true); // Ensure modal state is set to true
    };

    const handleClose = async () => {
        setIsMatchModalOpen(false); // Close the modal
        setIsUpcomingModalOpen(false);
        setSelectedMatch(null); // Reset selected match
        setSelectedUpcomingMatch(null);
        setUpcomingMatches([]);
        const response = await getUpcomingMatches();
        setUpcomingMatches(response);
    };

    return (
        <div className="container">
            <button className='btn btn-primary' onClick={() => handleUpcomingEdit(null)}>
                Opret nyt kamp
            </button>
            {/* Make checkbox for playoff check */}
            <div>
                <p>
                    <input type="checkbox" checked={filterMatches} onChange={(e) => setFilterMatches(e.target.checked)} />
                    Vis kampe som er blevet spillet i playoff
                </p>

            </div>
            {
                shownMatches.length > 0 && (
                    <>
                        <div className="text-center">Kommende games</div>
                        <div className="row">
                            {shownMatches.map((match, index) => (
                                <div className="col-md-4" key={index}>
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <div className="d-flex align-items-center justify-content-center mb-3">
                                                <img
                                                    src={match.team1.teamLogo}
                                                    alt={`${match.team1.teamName} logo`}
                                                    className="rounded-circle me-2"
                                                    style={{ width: "40px", height: "40px" }}
                                                />
                                                <span className="fw-bold">{match.team1.teamName}</span>
                                            </div>
                                            <h5 className="text-uppercase text-muted">vs</h5>
                                            <div className="d-flex align-items-center justify-content-center mb-3">
                                                <img
                                                    src={match.team2.teamLogo}
                                                    alt={`${match.team2.teamName} logo`}
                                                    className="rounded-circle me-2"
                                                    style={{ width: "40px", height: "40px" }}
                                                />
                                                <span className="fw-bold">{match.team2.teamName}</span>
                                            </div>
                                            <p className="text-muted mb-3">
                                                Match time: {new Date(match.match_time).toLocaleString()}
                                            </p>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => handleUpcomingEdit(match)}
                                            >
                                                Edit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )
            }

            {
                matches.length > 0 && (
                    <>
                        <div className='text-center'>
                            Færdige kampe
                        </div>
                        <div className='row'>
                            {matches.map((match, index) => (
                                <div className="col-md-4" key={index}>
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <div className="d-flex align-items-center justify-content-center mb-3">
                                                <img
                                                    src={match.team1.teamLogo}
                                                    alt={`${match.team1.teamName} logo`}
                                                    className="rounded-circle me-2"
                                                    style={{ width: "40px", height: "40px" }}
                                                />
                                                <span className="fw-bold">{match.team1.teamName}</span>
                                            </div>
                                            <h5 className="text-uppercase text-muted">vs</h5>
                                            <div className="d-flex align-items-center justify-content-center mb-3">
                                                <img
                                                    src={match.team2.teamLogo}
                                                    alt={`${match.team2.teamName} logo`}
                                                    className="rounded-circle me-2"
                                                    style={{ width: "40px", height: "40px" }}
                                                />
                                                <span className="fw-bold">{match.team2.teamName}</span>
                                            </div>
                                            <p className="text-muted mb-3">
                                                Match time: {new Date(match.match_time).toLocaleString()}
                                            </p>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => handleMatchEdit(match)}
                                            >
                                                Edit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )
            }

            {isUpcomingModalOpen && (
                <EditUpcomingMatchModal
                    match={selectedUpcomingMatch}
                    teams={allTeams}
                    onClose={handleClose}
                />
            )}
            {
                isMatchModalOpen && selectedMatch && (
                    <EditMatchModal match={selectedMatch} onClose={handleClose} />
                )
            }
        </div>
    );
};

export default AdminPage;
